/**
 * Single Services Infinite Loading
 * - Pokazuje kolejne sekcje .box podczas przewijania
 * - Pierwsza sekcja jest widoczna od razu (render z PHP)
 */
(function(){
  function initInfiniteServices() {
    if (!document.body.classList.contains('single-services')) return;

    const container = document.querySelector('.services-container__wrapper');
    const sentinel = document.querySelector('.services-infinite__sentinel');
    if (!container || !sentinel) return;

    // Zbierz wszystkie ukryte sekcje (poza pierwszą)
    const hiddenBoxes = Array.from(container.querySelectorAll('.box--hidden'));
    if (hiddenBoxes.length === 0) return;

    let index = 0; // który box odblokować następny

    const revealNext = () => {
      if (index < hiddenBoxes.length) {
        hiddenBoxes[index].classList.add('box--show');
        // opcjonalnie: płynne wejście
        hiddenBoxes[index].style.animation = 'fadeInUp 400ms ease-out';
        index++;
      }
    };

    // Od razu wczytaj pierwszy ukryty po starcie, by UX był płynny
    revealNext();

    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Za każdym razem gdy sentinel wejdzie w viewport, odkrywaj 1 kolejną sekcję
          revealNext();

          // Jeśli wszystko odkryte, przestań obserwować
          if (index >= hiddenBoxes.length) {
            io.disconnect();
          }
        }
      });
    }, { rootMargin: '0px 0px 200px 0px', threshold: 0.01 });

    io.observe(sentinel);
  }

  document.addEventListener('DOMContentLoaded', initInfiniteServices);
})();
